// extracted by mini-css-extract-plugin
module.exports = {"sciencebg":"science_sciencebg__2S0Xt","scienceStyle":"science_scienceStyle__3xW7m","sciencenews":"science_sciencenews__78uTH","underline":"science_underline__n9G3N"};